import React from 'react';
import { defaultImage } from '@/page-components/region/constants';
import WeSkiWidget from './WeSkiWidget';

const wrapperClass = 'relative lg:h-[780px] lg:pt-5';

const overlayClass = [
  'hidden lg:block',
  'lg:absolute lg:ml-[260px] lg:h-[600px] lg:w-[calc(100%-300px)]',
  'lg:rounded-[14px] lg:bg-cover lg:bg-center lg:bg-no-repeat',
].join(' ');

const widgetClass = [
  'lg:absolute lg:ml-[30px] lg:mt-[30px] lg:w-[516px] lg:rounded-[10px] lg:bg-white lg:p-5',
  'lg:shadow-[0_0_20px_rgba(0,0,0,0.2)]',
].join(' ');

const WeSkiPage = ({ destinationId, focusImage }: { destinationId: string, focusImage?: string }) => (
  <div className="w-full">
    <div className={wrapperClass}>
      <div
        className={overlayClass}
        style={{ backgroundImage: `url(${focusImage || defaultImage})` }}
      />
      <div className={widgetClass}>
        <WeSkiWidget destinationId={destinationId} withTopCopy />
      </div>
    </div>
  </div>
);

export default WeSkiPage;
